<template>
  <div :class="myContainerClass">
    <SnowDataPoint
      v-if="isSkeleton"
    >
      <span class="tw-block tw-w-10 skeleton-copy">{{ newSnow }}"</span>
      <template #label>
        <span class="tw-block tw-font-medium text-skeleton-color">Last 24 Hours</span>
      </template>
    </SnowDataPoint>
    <SnowNewSnowDataPoint
      v-else
      :location="location"
    />
  </div>
</template>

<script>
import { getLastPrecipSnow } from '@@/utils/CommonUtils';

export default {
  name: 'SnowReportSummary',

  props: {
    centered: {
      type: Boolean,
      default: false,
    },
    containerCenteredClass: {
      type: [Array, String],
      default: 'tw-py-3 lg:tw-py-2',
    },
    containerClass: {
      type: [Array, String],
      default: 'tw-pt-6 lg:tw-pt-4',
    },
    isSkeleton: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
  },

  computed: {
    newSnow() {
      return getLastPrecipSnow(this.location.history_snow_daily);
    },

    myContainerClass() {
      return this.centered ? this.containerCenteredClass : this.containerClass;
    },
  },
};
</script>
